import React from 'react';
import { connect } from 'react-redux';
import { store } from './redux/store';
import { QUERY_STRING_CHANGED } from './redux/types';

class QueryStringSerializer extends React.Component {

    dispatch = () =>
        store.dispatch({
            type: QUERY_STRING_CHANGED
        })

    componentDidMount = () => this.dispatch();
    componentDidUpdate = () => this.dispatch();
    render = () => null;
}

const mapStateToProps = (state) => ({ router: state.router });

export default connect(mapStateToProps)(QueryStringSerializer);